import React from 'react';
import { Grid, TextField, Button } from '@material-ui/core';
import RichTextEditor from '../../components/RichTextEditor';

class TrabalheConoscoTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        trabalhe_conosco_title: this.props.form.trabalhe_conosco_title,
        trabalhe_conosco_description: this.props.form.trabalhe_conosco_description,
        trabalhe_conosco_url: this.props.form.trabalhe_conosco_url,
        trabalhe_conosco_txt_btn: this.props.form.trabalhe_conosco_txt_btn,
      },
    };
  }

  handleChange = name => value => {
    let form = { ...this.state.form };
    form[name] = value.target ? value.target.value : value;
    this.setState({ form });

    this.props.onChange(form);
  };

  render() {
    return (
      <Grid container spacing={40} style={{ marginTop: 0 }}>
        <Grid item xs={12}>
          <TextField
            label="Título"
            value={this.state.form.trabalhe_conosco_title}
            onChange={this.handleChange('trabalhe_conosco_title')}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12}>
          <RichTextEditor
            value={this.state.form.trabalhe_conosco_description}
            onChange={this.handleChange('trabalhe_conosco_description')}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="URL de redirecionamento"
            value={this.state.form.trabalhe_conosco_url}
            onChange={this.handleChange('trabalhe_conosco_url')}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Texto do botão"
            value={this.state.form.trabalhe_conosco_txt_btn}
            onChange={this.handleChange('trabalhe_conosco_txt_btn')}
            fullWidth
            required
          />
        </Grid>

        <Grid item xs={12} style={{ textAlign: 'right' }}>
          <Button color="primary" onClick={this.props.onSubmit}>
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  }
}

export default TrabalheConoscoTab;
